<template>
  <page>
    <div class="row">
      <div class="col-md-6 col-lg-4 col-md-push-3 col-lg-push-4">
        <div class="panel panel-default">
          <div class="panel-body text-center">
            <h3>Gleymt lykilorð</h3>
            <div class="banner">
              <div class="bannerText">
                Vinsamlegast notið rafræn skilríki.
              </div>
            </div>
            <hr />

            <div class="alert alert-danger" v-if="errorList.length > 0" style="text-align: left">
              <ul class="list-unstyled">
                <li v-for="(e, idx) in errorList" :key="idx">
                  {{ e }}
                </li>
              </ul>
            </div>

            <p class="text-left" v-if="success">Leiðbeiningar hafa verið sendar í tölvupósti á skráð netföng í Innu.</p>

            <p class="text-left" v-if="!success">
              Sláðu inn kennitölu og ýttu síðan á takkann. Leiðbeiningar verða sendar í tölvupósti á skráð netföng í Innu.
            </p>

            <br v-if="!success" />

            <form novalidate @submit.prevent="validateBeforeSubmit" v-if="!success">
              <div class="form-group" v-bind:class="{ 'has-error': errors.has('username') }">
                <label class="sr-only" for="username">Kennitala</label>
                <input type="text" class="form-control" id="username" name="username" placeholder="Kennitala" v-model="username" v-validate="'required'" />
                <span class="help-block" v-if="errors.has('username:required')">Vinsamlegast sláðu inn kennitölu.</span>
              </div>
              <button type="submit" class="btn btn-login" style="width: 100%; height: 40px">GLEYMT LYKILORÐ</button>
            </form>

            <br />

            <a href="/innskraning">Aftur á innskráningarsíðu</a>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
/* global alert: false */

import config from '../services/config'

export default {
  name: 'login',
  data() {
    return {
      success: false,
      errorList: [],
      username: '',
      formSubmitted: false
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.errorList = []

      // Validate All returns a promise and provides the validation result.
      this.$validator.validateAll().then(success => {
        if (!success) {
          // handle error
          return
        }

        var credentials = {
          username: this.username
        }

        this.$http.post(config.FORGOT_PASSWORD_URL, credentials).then(
          response => {
            this.success = true
          },
          err => {
            if (err.status === 401) {
              this.errorList = [err.data.message]
            } else if (err.status === 400) {
              this.errorList = [err.data]
            } else {
              alert('Óvænt villa kom upp. Vinsamlegast reyndu aftur.')
            }
          }
        )
      })
    }
  },
  created() {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  /*float: right;*/
  padding: 15px;
  background-color: rgb(250, 192, 18);
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
}
.bannerText {
  text-align: center;
  margin: 1%;
  margin-top: 5px;
}
</style>
